import { useSession } from "PFApp/use_session";
import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import { ApiRoute } from "PFCore/utilities/routes";
import Pusher from "pusher-js";
import { useEffect } from "react";

import { useGlobalEvents } from "./use_global_events";

export const usePusher = () => {
  const { data: currentAccount } = useCurrentAccount();
  const session = useSession();

  useEffect(() => {
    if (window.PF.config.environment !== "production") {
      Pusher.log = (msg) => console.log(msg);
    }
    // @ts-ignore
    Pusher.host = window.PF.config.pusher_host;

    const token = session.getAccessToken();

    if (!token || !currentAccount?.full_domain) {
      return;
    }

    const pusher = new Pusher(window.PF.config.pusher_key || "", {
      authEndpoint: ApiRoute("/api/v1/pusher/auth"),
      cluster: window.PF.config.pusher_cluster || "eu",
      auth: {
        headers: {
          ACCOUNT: currentAccount.full_domain,
          PROFINDAAPITOKEN: token
        }
      }
    });

    // @ts-ignore
    window.newPusher = pusher;
  }, [currentAccount.full_domain]);

  useGlobalEvents();

  // @ts-ignore
  return window.newPusher;
};
